import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import "antd/dist/antd.css";
import { LocalizeProvider } from "react-localize-redux";
import globalTranslations from "./translations/global.json";
import { renderToStaticMarkup } from "react-dom/server";

const initialize = {
  languages: [
    { name: "English", code: "en" },
    { name: "Urdu", code: "ur" }
  ],
  translation: globalTranslations,
  options: {
    defaultLanguage: "en",
    renderToStaticMarkup
  }
}


ReactDOM.render(
  <React.StrictMode>
    <LocalizeProvider initialize={initialize} >
      <App />
    </LocalizeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);